import React, { useEffect } from "react";
import { useSelector } from "react-redux";

export default function Shownominee() {
    const ownerInfo = useSelector((state) => state.addressdetail.info2);
    // console.log("ownerInfo",ownerInfo)
; 
  return (
    <>
    <div className="d-flex px-3 row row-cols-xl-3 row-cols-lg-3 row-cols-md-2 row-cols-sm-1 row-cols-1">
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">NOMINEE NAME</div>
        <div className="indivtext">{ownerInfo?.Nname}</div>
      </div>
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">RELATIONSHIP WITH OWNER</div>
        <div className="indivtext">{ownerInfo?.Nrelation}</div>
      </div>
      <div className="py-2 px-2 text-nowrap col-xl-4 col-lg-4 col-md-6 col-sm-6 col-6">
        <div className="indivtexthead">NOMINEE DOB</div>
        <div className="indivtext">{ownerInfo?.Nage}</div>
      </div>
    </div>
    </>
  );
}
